<script>
    import SiteHeader from '../Public/SiteHeader'
    import RefreshIcon from 'vue-material-design-icons/Refresh.vue'; 
    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    import vToggle from 'v-toggle';
    import UserRow from '../../common/UserRow'

    export default {
        name: 'Index',
        components: {
            SiteHeader,
            RefreshIcon,
            DeleteIcon,
            vToggle,
            UserRow
        },
        created: () => {

        },
        async mounted () {

          this.loadUsers()
          var bodyElement = document.getElementsByTagName('body')[0];
          bodyElement.style.overflow = "auto"
        },
        data() {
            return {
                mykey: 'bar',
                users: [],
                educators: [],
                companies: [],
                loaded: false,
                filterAdmins: false,
                filterPending: false,
                currentTab: "educators"
            }
        },
        methods: {
          async loadUsers() {
            this.loaded = false
            var response = await this.$HTTP({
              method: 'get',
              fullUri: 'https://us-central1-chamber-of-commerce-dev.cloudfunctions.net/app/users',
              secure: true,
            })
            this.users = response.body
            this.users = this.users.map( u => { return {...u, showDetails: false } })
            this.filterUsers()
            this.loaded = true

            this.users.map( u => {
              var d = new Date(u.created)
              var created_formatted = new Intl.DateTimeFormat('en', { year: 'numeric', day: '2-digit', month: 'short' }).format(d)
              return { ...u, created_formatted: created_formatted }
            })
          },
          filterUsers(){
            this.loaded = false
            console.log("filtering users with filterAdmins value " + this.filterAdmins)
            this.educators = this.users.filter( u => { return u.type == 'Educator'} )
            this.companies = this.users.filter( u => { return u.type == 'Company'} )
            if ( this.filterAdmins === true ) {
              console.log("filtering admins because " + this.filterAdmins )
              this.educators = this.educators.filter( u => { return u.admin } )
              this.companies = this.companies.filter( u => { return u.admin } )
            }   
            if ( this.filterPending === true ) {
              console.log("filtering admins because " + this.filterAdmins )
              this.educators = this.educators.filter( u => { return !u.approved } )
              this.companies = this.companies.filter( u => { return !u.approved } )
            }               
            console.log("educator count: " + this.educators.length)       
            this.loaded = true
          },
          toggleAdminFilter() {
            this.filterAdmins = !this.filterAdmins
            if ( this.filterAdmins ) {
              this.filterPending = false // yes I know this is terrible
            }
            this.filterUsers()
          },
          togglePendingFilter() {
            this.filterPending = !this.filterPending
            if ( this.filterPending ) {
              this.filterAdmins = false
            }
            this.filterUsers()
          },          
          async toggleApproval( user,event  ){

            // the toggle component we are using doesn't handle clicks well.
            // if we use click.native, Vue puts the click handler on the underlying tag.
            // however, this component actually creates multiple tags (a label and input), so 
            // we have to check the tag name to make sure we only process the click once.
            console.log(event.target.tagName)
            if ( event.target.tagName == 'INPUT' ) {
              if ( user.approved ) {
                // true becoming false.  user wants to unapprove.
                this.unapproveUser( user )
              } else {
                this.approveUser( user )
              }
            }
          },
          async approveUser( user ){
            if (confirm("Approve user " + user.email + "? This will send them a welcome email.") ) {
              var response = await this.$HTTP({
                method: 'get',
                fullUri: 'https://us-central1-chamber-of-commerce-dev.cloudfunctions.net/app/approved_users/' + user.uid,
                secure: true,
              })
              user.approved = true
            } else {
              user.approved = false
              this.loadUsers()
            }
          },
          async unapproveUser( user ){
            if (confirm("Unapprove user " + user.email + "?" ) ) {
              var response = await this.$HTTP({
                method: 'delete',
                fullUri: 'https://us-central1-chamber-of-commerce-dev.cloudfunctions.net/app/approved_users/' + user.uid,
                secure: true,
              })
              user.approved = false
            } else {
              user.approved = true
              this.loadUsers()
            }
          },          
          async deleteUser( user ) {
            if (confirm("Delete user " + user.email + "? This cannot be undone.") ) {
              try {
                var response = await this.$HTTP({
                  method: 'delete',
                  fullUri: 'https://us-central1-chamber-of-commerce-dev.cloudfunctions.net/app/users/' + user.uid,
                  secure: true,
                })  
                this.loadUsers()              
              } catch( e ) {
                alert( "Error: " + e )
              }
            }
          }
        }
        
    }
</script>

<template lang="pug">
.foo
    site-header
    .row.tools
      .col.s12
        .refresh-holder
          refresh-icon.refresh(@click="loadUsers()")
        .admin-checkbox
          input.grade-checkbox(type="checkbox"
            true-value="yes"
            false-value="no"
            :checked="filterAdmins"
            @click="toggleAdminFilter()"
          )
          label Filter Admins
          br
          .admin-checkbox
          input.grade-checkbox(type="checkbox"
            true-value="yes"
            false-value="no"
            :checked="filterPending"
            @click="togglePendingFilter()"
          )   
          label Filter Unapproved          
    .row.lists
      .tab-container.col.s12
        .tab(v-bind:class="{ activeTab: currentTab == 'educators' }" @click="currentTab='educators'") Educators
        .tab(v-bind:class="{ activeTab: currentTab == 'industry' }" @click="currentTab='industry'") Industry Professionals
      .list#educators.col.s12( v-if="currentTab == 'educators'" )
        .foo( v-if="loaded" )               
          user-row(
            v-for="(user, idx) in educators" 
            :user="user"
            :key='idx'
            @toggleApproval="toggleApproval"
            @deleteUser="deleteUser"
          )           
        .foo(v-else)
          img.loading(src='@/assets/loader.gif')
      .list#companies.col.s12( v-if="currentTab == 'industry'" )
        .foo( v-if="loaded" )
          user-row(
            v-for="(user, idx) in companies" 
            :user="user"
            :key='idx'
            @toggleApproval="toggleApproval"
            @deleteUser="deleteUser"
          )                     
        .foo(v-else)
          img.loading(src='@/assets/loader.gif')
          

</template>

<style lang="sass" scoped>
@import '$vars'




.tab-container
  height: 60px; 
  font-size: 2em
  margin: 15px

.tab 
  float: left
  padding: 10px
  color: darkGray
  cursor: pointer
  border-radius: 5px;
  border: thin solid gray
  margin-right: 15px

@media screen and (max-width: 800px)
  .tab-container
    font-size: 1.5em

  .row.tools
    font-size: 1.3em

  .admin-checkbox
    label
      top: 3px
      position: relative


.activeTab
  color: white
  cursor: pointer  
  background-color: $chamber-orange !important

.tab:hover
  background-color: lightGray  
  color: white



label
  padding-left: 5px

.row.tools
  padding-bottom: 0px
  margin-bottom: 0px

.admin-checkbox, .refresh-holder
  display: block
  float: left
  padding-right: 10px

.admin-checkbox
  position: relative
  label
    font-size: 1em
    color: black
    padding-right: 5px

input
  opacity: 100 !important
  position: relative !important
  pointer-events: all !important

.nameHeader, .detailContainer
  float: left

.detailContainer
  margin-left: 5px
  cursor: pointer

.detailContainer:hover
  font-weight: bold    


.user_detail_block
  margin-left: 15px
  border: thin solid gray
  padding: 5px
  border-radius: 5px
  -webkit-box-shadow: -3px 3px 5px 0px rgba(0,0,0,0.5); 
  box-shadow: -3px 3px 5px 0px rgba(0,0,0,0.5);
  margin-bottom: 15px
  background-color: white



.lists
  width: 99%


td.delete-container, td.approval-container, .centered
  text-align: center

.delete-user
  font-size: 2.5em
  cursor: pointer

.delete-user:hover
  color: red  

.refresh
  font-size: 2em
  cursor: pointer

h4
  background-color: $chamber-orange
  padding: 10px
  border-radius: 5px;
  color: white
  font-style: italic
  font-weight: bold
  width: 95%;

.debugContainer
  display: block

img.loading
  width: 100px

table 
  margin-bottom: 40px
  width: 95%;

// tr:hover
//   background-color: #EEEEEE

td, th
  padding: 5px 5px

a
  cursor: pointer





</style>